var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("div", { staticClass: "subscription-block" }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _c("div", { staticClass: "body" }, [
            _c(
              "form",
              {
                staticClass: "input",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.sendForm($event)
                  }
                }
              },
              [
                _c("ui-input", {
                  attrs: {
                    large: _vm.adaptive.isDesktop,
                    clearable: "",
                    placeholder: "Email",
                    error: !!_vm.validationError
                  },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _c(
                  "div",
                  { staticClass: "button" },
                  [
                    _c("ui-button", {
                      attrs: {
                        type: "submit",
                        text: "Подписаться",
                        loading: _vm.progress,
                        disabled: !_vm.email || !!_vm.validationError,
                        large: "",
                        wide: ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("span", {
              class: { error: _vm.validationError },
              domProps: { innerHTML: _vm._s(_vm.substring) }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("h1", [_vm._v("Скидки, акции и новинки")]),
      _c("p", [_vm._v("Подписывайтесь на Email-рассылку")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }